module.exports = __webpack_public_path__ + "static/media/toggle-up.cc6c571c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/toggle-up.svg
// module id = 864
// module chunks = 0